import script from "./AssistedLivingCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistedLivingCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./AssistedLivingCoachingDigitalSignatureForm.vue?vue&type=style&index=0&id=552770da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552770da"]])

export default __exports__